module.exports = __webpack_public_path__ + "static/img/1.2840c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R141B/1.jpg
// module id = eSH4
// module chunks = 1